// extracted by css-extract-rspack-plugin
export default {"FilterPanelRoot":"pucht"};